import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext";
import './i18n'; // Import the i18n configuration

const clarityProjectId = 'wh2yrlj41f';

const initializeClarity = () => {
  const appEnv = process.env.REACT_APP_ENV;
  const isProduction = (appEnv || process.env.NODE_ENV) === 'production';

  if (!isProduction || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (window.clarity || document.querySelector(`script[src="https://www.clarity.ms/tag/${clarityProjectId}"]`)) {
    return;
  }

  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', clarityProjectId);
};

initializeClarity();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>,
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
